import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import MainSubHeading from "../Sub-Heading/MainSubHeading.jsx";
import datapulseq3 from "../../assets/events/datapulse q3.webp";
import newsletterQ3 from "../../assets/pdf/newsletter/IHUB DATA IIIT-H Q3 2024 Newsletter_compressed.pdf";
import dataPulsOctDec from "../../assets/events/dataPulseOct-Dec.webp";
import newsletterOctDec from "../../assets/pdf/newsletter/Newsletter-Oct-Dec-24.pdf";
import newsletteraprile25 from "../../assets/pdf/newsletter/IHUB-Q1-2025-Newsletter.pdf";
import dataplusaprile25 from "../../assets/events/dataplusaprile25.webp";
import datapulsejune25 from "../../assets/pdf/newsletter/Newsletter-april-june-2025.pdf";
import datapulseimgjune25 from "../../assets/events/data-pulse-april-june-2025.webp";
import datapulse from "../../assets/events/datapulse.webp";
import datapulseaprjun from "../../assets/events/dataplusaprjun.webp";
import newsletter from "../../assets/pdf/newsletter/IHUB_DATA_IIIT-H_Q1_2024_Newsletter_updated.pdf";
import newsletteraprjun from "../../assets/pdf/newsletter/ihub_data_jan_to_mar_2024.pdf";
import newsletteraprjun25Hero from "../../assets/events/dataplusQ3.png";
import newsletteraprjun25Pdf from "../../assets/pdf/newsletter/Newsletter-3Q-june-sep-25.pdf";
import newlatteroctdec25Hero from "../../assets/events/data-pluse-oct-dec-25.webp";
import newlatterjanmar26Hero from "../../assets/events/data-pluse-jan-mar-26.webp";
import newlatteroctdec25Pdf from "../../assets/pdf/newsletter/Oct-Dec 2025-Final-Newsletter.pdf";
import newlatterjanmar26Pdf from "../../assets/pdf/newsletter/IHub-Data_IIITH_Newsletter_Jan-Mar2026.pdf";
export default function Newsletter() {
  // const headingData = "IHUB-DATA 1";
  const subheadingData = "Newsletters"; // You should replace this with your actual subheading data
  return (
    <>
      <Container>
        {/* Page Heading Components */}
        <MainSubHeading subheading={subheadingData} />
        <Row>
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img
                  src={newlatterjanmar26Hero}
                  alt=""
                  className="img-fluid w-100"
                />
                <h6>
                  IHub-Data Newsletter Data Pulse
                  <br />
                  Jan to Mar 2026 edition
                </h6>
                <p>
                  We were delighted to host our peer hub IIT Mandi iHub and HCi
                  Foundation at IHub-Data, IIIT Hyderabad on February 26, 2026,
                  to explore....
                </p>
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}

                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    href={newlatterjanmar26Pdf}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img
                  src={newlatteroctdec25Hero}
                  alt=""
                  className="img-fluid w-100"
                />
                <h6>
                  IHub-Data Newsletter Data Pulse
                  <br />
                  Oct to Dec 2025 edition
                </h6>
                <p>
                  VahanEye is a real-time ANPR solution built on an indigenously
                  developed tech stack, combining video analytics, license plate
                  detection, and OCR....
                </p>
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}

                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    href={newlatteroctdec25Pdf}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img
                  src={newsletteraprjun25Hero}
                  alt=""
                  className="img-fluid w-100"
                />
                <h6>
                  IHub-Data Newsletter Data Pulse
                  <br />
                  July to Sep 2025 edition
                </h6>
                <p>
                  At IHub-Data, we continue to push the boundaries of applied AI
                  through collaboration, research translation, and impactful
                  outreach. This quarter....
                </p>
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}

                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    href={newsletteraprjun25Pdf}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img
                  src={datapulseimgjune25}
                  alt=""
                  className="img-fluid w-100"
                />
                <h6>
                  IHub-Data Newsletter Data Pulse <br />
                  (April to June 2025 edition)
                </h6>
                <p>
                  Driven by data, defined by impact — we believe in transforming
                  challenges into opportunities through collaboration and
                  research....
                </p>
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}

                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    href={datapulsejune25}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img
                  src={dataplusaprile25}
                  alt=""
                  className="img-fluid w-100"
                />
                <h6>
                  IHub-Data Newsletter Data Pulse <br />
                  (Jan to Mar 2025 edition)
                </h6>
                <p>
                  Launched in January 2025, India Data Org is an integrated
                  ecosystem designed to enhance dataset sharing and model
                  publication...
                </p>
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}

                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    href={newsletteraprile25}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={dataPulsOctDec} alt="" className="img-fluid w-100" />
                <h6>
                  IHub-Data Newsletter Data Pulse (Oct to Dec 2024 edition)
                </h6>
                <p>
                  Learn about all our activities and initiatives in the last
                  quarter of 2024 in this newsletter. Get information on ongoing
                  Startup Funding Opportunities...
                </p>
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}

                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    href={newsletterOctDec}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={datapulseq3} alt="" className="img-fluid w-100" />
                <h6>
                  IHub-Data Newsletter Data Pulse (July to Sep 2024 edition)
                </h6>
                <p>
                  Read about the events and activities of IHub-Data in the third
                  quarter of 2024 in the latest edition of our newsletter. Also,
                  don't miss our blogs in this edition...
                </p>
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}

                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    href={newsletterQ3}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={datapulseaprjun} alt="" className="img-fluid w-100" />
                <h6>
                  IHub-Data Newsletter Data Pulse <br />
                  (April to June 2024 edition)
                </h6>
                <p>
                  IHub-Data, IIIT Hyderabad showcased roadmap and startups at
                  the 4th TIPS conference held at IIT Bombay. We hosted the
                  Surveyor General of India...
                </p>
                <div className="red-mr-btn">
                  {/* <Link className='border-0 home-btn-rd-more' variant="primary" to="symposium-on-simulator-platform">Read More</Link> */}

                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    target="__blank"
                    href={newsletter}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4}>
            <div className="p-3">
              <div className="card-int">
                <img src={datapulse} alt="" className="img-fluid w-100" />
                <h6>
                  IHub-Data Newsletter Data Pulse <br />
                  (Jan to Mar 2024 edition)
                </h6>
                <p>
                  Read about all the events and updates of IHub-Data in the
                  first quarter of 2024 here. The highlights this quarter
                  include DST Secretary Prof Abhay Karandikar's visit....
                </p>

                <div className="red-mr-btn">
                  <Button
                    className="border-0 home-btn-rd-more"
                    variant="primary"
                    target="__blank"
                    href={newsletteraprjun}
                  >
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
